export default "__VITE_ASSET__DP4$7en6__";